import { type IconName } from '@launchpad-ui/icons';

import { linkableResourceTypes } from './internal/linkableResourceTypes';
import { type LinkableResourceType } from './types';

export { linkableResourceTypes } from './internal/linkableResourceTypes';

export function isLinkableResourceType(value: string): value is LinkableResourceType {
  return linkableResourceTypes.some((resourceType) => resourceType === value);
}

const LINKABLE_RESOURCE_TYPE_TEXT: {
  [key in LinkableResourceType]: { upper: string; lower: string };
} = {
  flags: {
    upper: 'Flag',
    lower: 'flag',
  },
  segments: {
    upper: 'Segment',
    lower: 'segment',
  },
  metrics: {
    upper: 'Metric',
    lower: 'metric',
  },
  'ai-configs': {
    upper: 'AI Config',
    lower: 'AI config',
  },
};

export const getIconForResourceType = (resourceType: LinkableResourceType): IconName => {
  switch (resourceType) {
    case 'flags':
      return 'flag-outline';
    case 'segments':
      return 'chart-venn';
    case 'metrics':
      return 'ruler';
    case 'ai-configs':
      return 'hub';
    default:
      throw new Error(`Unsupported resource type: ${resourceType}`);
  }
};

export const getHumanLinkableResourceType = (resourceType: LinkableResourceType) => {
  return LINKABLE_RESOURCE_TYPE_TEXT[resourceType];
};

export const linkableResourceTypeToAPIType = (resourceType: LinkableResourceType) => {
  switch (resourceType) {
    case 'flags':
      return 'flags' as const;
    case 'segments':
      return 'segments' as const;
    case 'metrics':
      return 'metrics' as const;
    case 'ai-configs':
      return 'aiConfigs' as const;
    default:
      throw new Error(`Unsupported resource type: ${resourceType}`);
  }
};
